// Role permission helpers - single source of truth
export const ROLES = {
  ADMIN: 'admin',
  TOPLEVMAN: 'toplevman',
  MANAGER: 'manager',
  HR: 'hr',
  MARKETING: 'marketing',
  EXECUTIVE: 'executive',
};

export const can = {
  viewAllLeads:    (r) => ['admin','toplevman','manager'].includes(r),
  assignLeads:     (r) => ['admin','toplevman','manager'].includes(r),
  uploadBulk:      (r) => r === 'admin',
  softDeleteLead:  (r) => ['admin','toplevman'].includes(r),
  permDeleteLead:  (r) => r === 'admin',
  viewReports:     (r) => ['admin','toplevman','manager','marketing'].includes(r),
  viewDashboard:   (r) => ['admin','toplevman','manager','marketing'].includes(r),
  viewPayroll:     (r) => ['admin','toplevman','hr','manager'].includes(r),
  manageTeam:      (r) => r === 'admin',
  manageSettings:  (r) => r === 'admin',
  viewAdminPanel:  (r) => r === 'admin',
  viewAuditLogs:   (r) => ['admin','toplevman'].includes(r),
  viewLeadGroups:  (r) => ['admin','marketing','toplevman'].includes(r),
  viewProperties:  (r) => ['admin','toplevman','manager','marketing'].includes(r),
  metaAds:         (r) => ['admin','marketing'].includes(r),
};
